import { render, staticRenderFns } from "./index.vue?vue&type=template&id=064635f4&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=064635f4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064635f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('064635f4')) {
      api.createRecord('064635f4', component.options)
    } else {
      api.reload('064635f4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=064635f4&scoped=true", function () {
      api.rerender('064635f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contents/mission/index.vue"
export default component.exports